export default "__VITE_ASSET__DE7wAVc1__"